var Flickity = require("flickity")
import Player from "@vimeo/player"
// var YouTubeIframeLoader = require('youtube-iframe');

let player

// Initialization
const slider = document.querySelector(".enable-carousel")
const sliderWrapperHero = document.querySelector(".carousel-wrapper")
const sliderOfOneVersion = document.querySelector(".homepage-one-slide")

let isContainVideoContent

if (sliderOfOneVersion) {
  isContainVideoContent = sliderOfOneVersion.querySelector(".videoContent")
}

let durationHero = 0
const intervalHero = 10

if (slider) {
  durationHero = parseInt(slider.getAttribute("data-duration"))
}

if (slider || isContainVideoContent !== null) {
  function loadScript() {
    if (typeof YT == "undefined" || typeof YT.Player == "undefined") {
      var tag = document.createElement("script")
      tag.src = "https://www.youtube.com/iframe_api"
      var firstScriptTag = document.getElementsByTagName("script")[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  function loadPlayer() {
    window.onYouTubePlayerAPIReady = function () {
      onYouTubePlayer()
    }
  }

  $(function () {
    loadScript()
  })

  window.addEventListener("load", (event) => {
    // let tag = document.createElement("script");
    // tag.src = "https://www.youtube.com/iframe_api";
    // let firstScriptTag = document.getElementsByTagName("script")[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let allVideosDiv = document.getElementsByClassName("videoBG")
    let falsePlay = false

    var isCampaign = false
    if (document.querySelector("#fullpage")) {
      isCampaign = document.querySelector("#fullpage").classList.contains("fullpage-campaign") ? true : false
    }

    for (var i = 0; i < allVideosDiv.length; i++) {
      let videoBgID = allVideosDiv[i].id

      let playVideoID = document.getElementById(videoBgID)

      if (playVideoID) {
        const youtubeID = playVideoID.getAttribute("data-youtube-bg")
        const vimeoID = playVideoID.getAttribute("data-vimeo-bg")
        const youkuID = playVideoID.getAttribute("data-youku-bg")

        if (playVideoID.classList.contains("dontPlay")) {
          falsePlay = true
        }
        if (youtubeID) {
          onYouTubeIframeAPIReadyCustom(youtubeID, playVideoID)
        }
        if (vimeoID) {
          vimeoPlayModal(vimeoID)
        }
        if (youkuID && !isCampaign) {
          youkuPlayModal(youkuID)
        }
      }

      function onYouTubeIframeAPIReadyCustom(youtubeID) {
        let ifCompletedOnce = false
        player = new YT.Player(videoBgID, {
          height: "100%",
          width: "100%",
          videoId: youtubeID,
          host: "https://www.youtube.com",
          playerVars: {
            autoplay: falsePlay ? 0 : 1,
            autohide: 1,
            disablekb: 1,
            controls: isCampaign ? 1 : 0,
            showinfo: 0,
            modestbranding: 1,
            loop: 1,
            fs: 0,
            rel: 0,
            enablejsapi: 1,
            playlist: youtubeID,
          },
          events: {
            onReady: function (e) {
              if (!isCampaign) {
                e.target.mute()
              }
              track("Video", "Loaded")
              e.target.playVideo()
            },
            onStateChange: function (e) {
              if (e.data === YT.PlayerState.PLAYING) {
                document.getElementById(videoBgID).classList.add("loaded")
                track("Video", "Played")
              }
              if (e.data === YT.PlayerState.PAUSED) {
                let currentTime = e.target.getCurrentTime()
                let duration = e.target.getDuration()
                var completionPercentage = Math.round((currentTime / duration) * 100)
                track("Video", "Paused")
                if (!ifCompletedOnce) {
                  track("Video", "Watched " + completionPercentage + "%")
                }
              }
              if (e.data === YT.PlayerState.ENDED) {
                track("Video", "Watched 100%")
                ifCompletedOnce = true
                player.seekTo(0)
              }
            },
          },
        })
      }

      function vimeoPlayModal(vimeoID) {
        let ifCompletedOnce = false
        player = new Player(videoBgID, {
          id: vimeoID,
          muted: isCampaign ? 0 : 1,
          background: 1,
          autoplay: true,
          controls: false,
        })
        player.on("play", function (e) {
          document.getElementById(videoBgID).firstChild.classList.add("loaded")
          track("Video", "Played")
        })
        player.on("pause", function (e) {
          var completionPercentage = Math.round(e.percent * 100)
          if (completionPercentage != 100) {
            track("Video", "Paused")
            if (!ifCompletedOnce) {
              track("Video", "Watched " + completionPercentage + "%")
            }
          }
        })
        player.on("ended", function (e) {
          track("Video", "Watched 100%")
          ifCompletedOnce = true
          player.setCurrentTime(0)
          setTimeout(function () {
            player.play()
          }, 300)
        })
      }

      function youkuPlayModal(youkuID) {
        player = new YKU.Player(videoBgID, {
          client_id: "7a0aef3c0f591880",
          vid: youkuID,
          autoplay: true,
          show_related: false,
          events: {
            onPlayerReady: function () {
              document.getElementById(videoBgID).classList.add("loaded")
            },
          },
        })
      }

      $(".play-fullscreen-video").on("click", function (e) {
        if ($(".videoBG").attr("data-youtube-bg") != null) {
          player.playVideo()
        } else if ($(".videoBG").attr("data-vimeo-bg") != null) {
          player.play()
        } else if ($(".videoBG").attr("data-youku-bg") != null) {
          const youkuID = playVideoID.getAttribute("data-youku-bg")
          youkuPlayModal(youkuID)
        }
        $(this).hide()
        $(".campaign-video-title").slideUp(300)
        setTimeout(function () {
          $(".videoContent > .bkg__overlay, .videoContent > .full-screen-img").fadeOut("slow")
        }, 100)
      })

      if (isCampaign && $(window).width() < 992) {
        $(window).on("scroll", function () {
          var scrollPosition = scrollY || pageYOffset
          if (scrollPosition > $("#section2").position().top - $(window).height() + $(window).height() / 2) {
            $(".campaign-video-title").slideDown(300)
            $(
              ".videoContent > .bkg__overlay, .videoContent > .full-screen-img, .play-fullscreen-video, .videoContent > .campaign-logo, .fullpage-campaign .scroll-down"
            ).fadeIn()
            if ($(".videoBG").attr("data-youku-bg") != null) {
              $(".videoBG").empty()
            } else {
              player.pauseVideo()
            }
            setTimeout(() => {
              fullpage_api.reBuild()
            }, 700)
          }
        })
      }
    }

    //Hero component

    //.carousel-cell.is-selected
    if (slider) {
      if (slider.dataset.durationHero) durationHero = slider.dataset.durationHero

      // var progressBar = $('.progress');
      // var progressBar = $('.dot.is-selected');

      var flkyHero = new Flickity(".hero-carousel", {
        // accessibility: true,
        // enable keyboard header-navigation, pressing left & right keys

        adaptiveHeight: false,
        // set carousel height to the selected slide

        //* autoPlay: true,
        // advances to the next cell
        // if true, default is 3 seconds
        // or set time between advances in milliseconds
        // i.e. `autoPlay: 1000` will advance every 1 second

        //* autoPlay: 4000, // {Number}
        // advance cells ever {Number} milliseconds
        // 1500 will advance cells every 1.5 seconds

        // pauseAutoPlayOnHover: true,
        pauseAutoPlayOnHover: false,

        cellAlign: "left",
        // alignment of cells, '100%', 'left', or 'right'
        // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)

        cellSelector: ".carousel-cell",
        // specify selector for cell elements

        fade: true,

        imagesLoaded: true,

        selectedAttraction: 0.01,
        friction: 0.15,
        // friction: 0.2,
        // smaller number = easier to flick farther
        // lower attraction and lower friction
        // slower transitions
        // easier to flick past cells
        // Default selectedAttraction: 0.025.
        // Default friction: 0.28

        contain: false, //Fade
        // will contain cells to container
        // so no excess scroll at beginning or end
        // has no effect if wrapAround is enabled

        draggable: false,
        // draggable: '>1',
        // enables dragging & flicking
        // if at least 2 cells

        // dragThreshold: 3,
        // number of pixels a user must scroll horizontally to start dragging
        // increase to allow more room for vertical scroll for touch devices

        freeScroll: false,
        // enables content to be freely scrolled and flicked
        // without aligning cells

        groupCells: false,
        // group cells together in slides

        initialIndex: 0,
        // zero-based index of the initial selected cell

        lazyLoad: 1,
        //true, data-flickity-lazyload
        // enable lazy-loading images
        // set img data-flickity-lazyload="src.jpg"
        // set to number to load images adjacent cells

        percentPosition: true,
        // sets positioning in percent values, rather than pixels
        // Enable if items have percent widths
        // Disable if items have pixel widths, like images

        prevNextButtons: false,
        // creates and enables buttons to click to previous & next cells

        pageDots: true,
        // create and enable page dots

        resize: true,
        // listens to window resize events to adjust size & positions

        rightToLeft: false,
        // enables right-to-left layout

        setGallerySize: true,
        // sets the height of gallery
        // disable if gallery already has height set with CSS

        watchCSS: false,
        // watches the content of :after of the element
        // activates if #element:after { content: 'flickity' }

        wrapAround: true,
        // at end of cells, wraps-around to first for infinite scrolling
      })

      // const flictyHeroDots = $('.hero-carousel .flickity-page-dots .dot');
      // const selectedDotSpan = $('.hero-carousel .dot.is-selected span');
      // const HeroDotSpan =  $('.hero-carousel .dot span');

      // Pause control
      var isPausedHero = false

      //   sliderWrapperHero.addEventListener('mouseenter', function () {
      //      isPausedHero = true;
      //   });

      // sliderWrapperHero.addEventListener('mousemove', function () {
      //    isPausedHero = true;
      // });

      sliderWrapperHero.addEventListener("mouseleave", function () {
        //isPausedHero = false;
        isPausedHero = false
      })

      // Main function
      var percentTimeHero, stepHero, tickHero

      function heroAnalytics(isCLicked) {
        let heroElm = $(".hero-img-cover.is-selected")
        let imageUrl = heroElm.find(".hero-img").attr("src")
        let slideNumber = heroElm.index() + 1
        let htmlOfElm = ".hero-carousel.enable-carousel"
        let displayType = "auto"

        if (isCLicked) {
          displayType = "manual"
        }
        track("Homepage", "Hero Slider " + slideNumber + " Displayed", {
          displayMethod: displayType,
        })
      }

      function startProgressbarHero() {
        resetProgressbarHero()
        percentTimeHero = 0
        isPausedHero = false //false
        tickHero = window.setInterval(increase, intervalHero)
      }

      function increase() {
        if (!isPausedHero) {
          stepHero = (durationHero * 1000) / intervalHero
          percentTimeHero += 100 / stepHero

          //progressBar.style.width = percentTimeHero + "%";
          $(".hero-carousel .dot span").css("width", "0%")
          $(".hero-carousel .dot.is-selected span").css("width", percentTimeHero + "%")
          //$('.dot.is-selected').css("width", percentTimeHero + '%');

          if (percentTimeHero >= 100) {
            flkyHero.next()
            startProgressbarHero()
            heroAnalytics()
          }
        }
      }

      function resetProgressbarHero() {
        $(".hero-carousel .dot.is-selected span").css("width", "0%")
        clearTimeout(tickHero)
      }

      startProgressbarHero()

      //Moving dots
      //  $('.hero-carousel .flickity-page-dots').appendTo(".hero-container")
      $(".hero-carousel .flickity-page-dots").wrap("<div class='container'></div>")
      $(".hero-carousel .flickity-page-dots .dot").each(function () {
        $(this).append("<span></span>")
      })

      $(".hero-carousel .flickity-page-dots .dot").bind("DOMSubtreeModified", function () {
        stepHero = (durationHero * 1000) / intervalHero
        percentTimeHero = 0
        $(".hero-carousel .dot span").css("width", "0%")
        $(".hero-carousel .dot.is-selected span").css("width", 0 + "%")
      })

      $(".hero-carousel .flickity-page-dots .dot").on("click", function (e) {
        isPausedHero = true // false;

        setTimeout(function () {
          heroAnalytics(true)
        }, 100)
      })

      $(".carousel-wrapper .scroll-down-btn").on("click", function () {
        const yOffset = -64
        const element = document.getElementsByTagName("main")[0]
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({top: y, behavior: "smooth"})
      })

      let target = document.querySelectorAll(".enable-carousel .hero-container")
      let static_banner = document.querySelector(".enable-carousel .static-banner")
      let target_height = target[0].clientHeight
      let static_banner_height = static_banner.clientHeight
      let banner_opacity = target_height - static_banner_height - 100
      let dots = document.querySelector(".hero-carousel  .flickity-page-dots")
      // let scroll_down_btn = document.querySelector('.scroll-down-btn')

      window.addEventListener("scroll", (e) => {
        let scrolled = window.pageYOffset
        let rate = scrolled * -0.2

        // elements.style.transform = "translate3d(0px," + rate + "px, 0px)";
        // $('.hero-img:visible').css('margin-top', rate + 'px')

        //Static Banner position and opacity
        $(".enable-carousel .hero-container").css("transform", "translate3d(0px," + scrolled * 0.6 + "px, 0px)")
        $(".enable-carousel .static-banner").css("opacity", 1 - (scrolled * 1.5) / banner_opacity)

        //Hide dots
        // let op = 1 - scrolled * 0.0099;
        dots.style.opacity = scrolled > 100 ? 0 : 1
        // scroll_down_btn.style.opacity = scrolled > 100 ? 0 : 1

        if (isPausedHero && scrolled >= target_height / 1.5) isPausedHero = false
      })
    }
  })
}
